{
  "views": {
    "front": "表面",
    "back": "裏面",
    "corner_tl": "左上の角",
    "corner_tr": "右上の角",
    "corner_bl": "左下の角",
    "corner_br": "右下の角",
    "label": "鑑定ラベル",
    "zoom": "拡大",
    "surface": "光を当てた表面",
    "edge": "側面"
  },
  "views_hint": {
    "front": "カード全体を枠に入れて表面を撮影",
    "back": "裏返して裏面全体を枠に入れる",
    "corner_tl": "左上の角を近くで",
    "corner_tr": "右上の角を近くで",
    "corner_bl": "左下の角を近くで",
    "corner_br": "右下の角を近くで",
    "label": "鑑定番号が見えるラベル",
    "zoom": "お客様に見せたい傷や細部",
    "surface": "光を当てて傷が見える角度で",
    "edge": "カードまたはケースの側面"
  },
  "camera": {
    "step": "{{count}} 枚中 {{n}} 枚目：{{name}}",
    "title": "カメラ",
    "close": "カメラを閉じる",
    "denied": "カメラが許可されていません。ブラウザの設定でこのサイトのカメラを許可するか、「画像を選ぶ」を使ってください。",
    "unavailable": "この端末にカメラが見つかりません。「画像を選ぶ」を使ってください。",
    "retake": "撮り直す",
    "shoot": "撮影",
    "skip": "スキップ"
  },
  "gallery": {
    "edit_alt": "説明を編集",
    "alt_title": "画像の説明",
    "alt_hint": "目の不自由なお客様への読み上げや検索エンジンに使われます。",
    "alt_en": "英語",
    "alt_th": "タイ語",
    "alt_save": "保存",
    "picture_n": "{{count}} 枚中 {{n}} 枚目",
    "sortable": "並べ替えできる画像",
    "main": "メイン",
    "move_earlier": "{{name}} を前へ",
    "move_later": "{{name}} を後ろへ",
    "make_main": "{{name}} をメイン画像にする",
    "remove": "{{name}} を外す",
    "moved": "{{from}} 枚目の画像が {{count}} 枚中 {{to}} 枚目になりました",
    "removed": "{{n}} 枚目の画像を外しました",
    "keys_hint": "矢印キーで移動、Home でメイン画像、Delete で外します。",
    "removed_toast": "画像を外しました",
    "alt_failed": "説明を保存できませんでした。もう一度お試しください"
  },
  "uploader": {
    "progress": "{{name}} をアップロード中",
    "heic_note": "iPhone の写真（HEIC）はアップロード後に変換されます。",
    "retry": "もう一度",
    "cancel": "{{name}} のアップロードを止める",
    "dismiss": "{{name}} を一覧から消す",
    "too_many": "画像は {{max}} 枚までです。{{left}} 枚は追加されませんでした。",
    "camera_step": "撮影：{{name}}（{{n}}/{{count}}）",
    "camera": "写真を撮る",
    "camera_one": "写真を撮る",
    "count": "{{max}} 枚中 {{count}} 枚",
    "remove_file": "外す",
    "no_photos": "まだ画像がありません。販売する前に少なくとも表面を追加してください。",
    "in_progress": "アップロード中のファイル",
    "drop_zone": "画像を追加：ここにドロップ、貼り付け、またはボタン",
    "secure_note": "暗号化して保存されます。権限のあるスタッフだけが開けます。",
    "drop_hint_many": "ここに画像をドロップ・貼り付け、またはボタンを使ってください。自動でアップロードされます。",
    "drop_hint_one": "ここにファイルをドロップ・貼り付け、またはボタンを使ってください。",
    "choose_many": "画像を選ぶ",
    "choose_one": "ファイルを選ぶ",
    "pick_existing": "アップロード済みの画像を使う",
    "skip_step": "この写真をとばす",
    "full": "{{max}} 枚すべて使っています。追加するには画像を外してください。",
    "busy_other": "{{count}} 件アップロード中…"
  },
  "status": {
    "preparing": "準備中…",
    "waiting": "待機中…",
    "uploading": "アップロード中…",
    "processing": "もう少しです…",
    "offline": "インターネットなし — 戻ると自動で再開",
    "ready": "完了",
    "failed": "アップロードできませんでした",
    "rejected": "受け付けられません",
    "cancelled": "停止しました"
  },
  "problem": {
    "not_image": "このファイルは画像ではありません。",
    "type": "このファイルはここでは使えません。JPEG・PNG・WebP・iPhone の写真を使ってください。",
    "too_large": "ファイルが大きすぎます。",
    "empty": "ファイルが空です。",
    "size_mismatch": "アップロード中にファイルが変わりました。もう一度お試しください。",
    "corrupt_file": "ファイルが壊れていて開けません。",
    "processing_failed": "画像を準備できませんでした。もう一度アップロードしてください。",
    "processing_timeout": "いつもより時間がかかっています。あとで表示されるかもしれません。もう一度お試しください。",
    "network_error": "接続が切れました。もう一度お試しください。",
    "other": "このファイルは使えません。"
  },
  "restricted": {
    "stored": "安全に保存されています",
    "alt": "保存された書類",
    "error": "ファイルを開けませんでした。もう一度試すか、店長に相談してください。",
    "hide": "隠す",
    "loading": "開いています…",
    "show": "表示",
    "note": "表示すると記録されます。画像はこの端末に保存されません。"
  },
  "picker": {
    "title": "アップロード済みの画像",
    "close": "閉じる",
    "search": "名前や説明で検索",
    "loading": "読み込み中…",
    "error": "画像を読み込めませんでした。",
    "empty": "画像が見つかりません。",
    "results": "画像",
    "picture": "画像",
    "more": "もっと見る",
    "cancel": "キャンセル",
    "add_other": "{{count}} 枚を追加"
  }
}
